import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import App from './App';
import createStore, { history } from './configureStore';
import { initializeAnalytics } from './service/analytics/analytics.service';
import { registerAxiosAuthInterceptor } from './api/common/axiosAuthInterceptor';

const store = createStore();
registerAxiosAuthInterceptor(store.dispatch);
initializeAnalytics(store, history);

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
// serviceWorker.unregister();
